import { render, staticRenderFns } from "./UniInfor.vue?vue&type=template&id=023d4366&"
import script from "./UniInfor.vue?vue&type=script&lang=js&"
export * from "./UniInfor.vue?vue&type=script&lang=js&"
import style0 from "./UniInfor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports